<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	<!----------- 所有退货记录查询条件 -------------->
    	<el-form :inline="true" class="formmore backborder1 demo-form-inline" size="small">
    		<el-form-item>
    			<el-date-picker v-model="order.date" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%" @change="orderisselect=true" :unlink-panels="false"></el-date-picker>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.applyid" filterable clearable placeholder="请选择供应商" @change="orderisselect=true">
			        <el-option v-for="(item,index) in allapplylists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.warehouse" clearable placeholder="请选择仓库" @change="orderisselect=true">
			        <el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.status" clearable placeholder="请选择状态" @change="orderisselect=true">
			        <el-option v-for="(item,index) in statuslists" :label="item.name" value="a0" :key="index" v-if="item.id==0"></el-option>
			        <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index" v-if="item.id > 0"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.account" clearable placeholder="请选择支付类型" @change="orderisselect=true">
			        <el-option v-for="(item,index) in accountLists" :label="item.name" value="a0" :key="index" v-if="item.id==0"></el-option>
			        <el-option v-for="(item,index) in accountLists" :label="item.name" :value="item.id" :key="index" v-if="item.id > 0"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.type" clearable placeholder="请选择来源" @change="orderisselect=true">
			        <el-option v-for="(item,index) in ordertype" :label="item.name" :value="item.id" :key="index"></el-option>
			    </el-select>
    		</el-form-item>
        <el-form-item>
    			<el-input placeholder="请输入订单号 / 采购单号" v-model="order.key" clearable style="width:100%" @change="orderisselect=true"></el-input>
    		</el-form-item>
        <el-form-item>
    			  <el-button type="warning" icon="el-icon-search" @click="getOrderlists">查询</el-button>		    
    		</el-form-item>
        <el-form-item>
    			  <el-button type="warning" icon="el-icon-plus" :loading="addneworderLoading" @click="addnews"  v-if="actionauth.order_storage_add=='true' && isverifystorage==false">新增</el-button>		    
    		</el-form-item>
        <el-form-item>
			      <el-tooltip class="item" effect="dark" content="您已开启按采购单生成进货入库单" placement="top" v-if="actionauth.order_storage_add=='true' && isverifystorage==true">
    				    <el-button type="info" icon="el-icon-plus">新增</el-button>			            				
  				  </el-tooltip>		    
    		</el-form-item>
    	</el-form>
    	
    	<div class="backborder2" style="margin-top:10px">
	    	<el-table :data="orderlists" style="width: 100%" v-loading="orderListLoading">
	    		  <el-table-column type="expand">
		            <template slot-scope="props">
		            <div style="width:99%;color:#606266;padding:15px 0;font-size:13px;"><span>备注：{{props.row.note}}</span></div>
		            <el-table :data="props.row.goods">
		                <el-table-column prop="name" label="商品名称" min-width="250">
                        <template slot-scope="scope">
                        <div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.name}}</div>
                        <div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">编号：{{scope.row.number}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="进货价" min-width="120" align="center">
                        <template slot-scope="scope">{{scope.row.buy|CFMprice}}</template>
                    </el-table-column>
		                <el-table-column prop="num" label="数量" min-width="120" align="center">
                        <template slot-scope="scope">
                        <div style="float:left;width:100%;font-size:14px;line-height:23px">{{scope.row.num}} {{scope.row.unit}}</div>
                        </template>
                    </el-table-column>
		                <el-table-column label="合计" min-width="120" align="center">
                        <template slot-scope="scope">{{scope.row.total|CFMprice}}</template>
                    </el-table-column>
		                <el-table-column label="状态" min-width="100" align="center">
                      <template slot-scope="scope">
                        <div v-if="scope.row.status==0" style="font-size:13px">未审核</div>
                        <div v-if="scope.row.status==1" style="font-size:13px">已审核</div>
                        <div v-if="scope.row.status==2" style="font-size:13px">已完成</div>
                        <div v-if="scope.row.status==3" style="font-size:13px">已退货</div>
                      </template>
                    </el-table-column>
		            </el-table>
		            </template>
	          </el-table-column>
            
            <el-table-column label="ID" width="120" align="center">
                <template slot-scope="scope">
                    <div style="float:left;width:100%;text-align:center;font-size:14px;line-height:23px">{{scope.row.id}}</div>
                    <div style="float:left;width:100%;text-align:center;font-size:12px;line-height:23px;color:#999999">（打印次数：{{scope.row.printnumber}}）</div>
                </template>
            </el-table-column>
		        <el-table-column label="进货单号" align="left" min-width="200">
		        	  <template slot-scope="scope">
                    <span v-if="scope.row.type==1" style="width:100%;float:left;">{{scope.row.documents}}</span>
                    <el-badge v-if="['2','3','4'].includes(scope.row.type)" :value="typeTemp[scope.row.type]" class="item"  type="success" style="margin-top:10px;margin-right:0" >
                      <span>{{scope.row.documents}}</span>
                    </el-badge>
			          </template>
		        </el-table-column>
            <el-table-column label="供应商" prop="applyname" min-width="140" align="center">
                <template slot-scope="scope">
                <span style="font-size:13px">{{scope.row.applyname}}</span>
                </template>
            </el-table-column>
             <el-table-column label="订单总价" align="center" min-width="140">
                <template slot-scope="scope">{{scope.row.total|CFMprice}}</template>
            </el-table-column>
            <el-table-column label="进货时间" prop="inputtime" align="center" min-width="140"></el-table-column>
		        <el-table-column label="入库仓库" prop="warehousename" align="center" min-width="140">
                <template slot-scope="scope">
                <span style="font-size:13px">{{scope.row.warehousename}}</span>
                </template>
            </el-table-column>
		        <el-table-column label="支付方式" align="center" min-width="140">
		        	<template slot-scope="scope">
                 <div style="float:left;width:100%;font-size:13px;line-height:23px;text-align:center;">
                    {{scope.row.account==0 ? '未付款' : scope.row.accountname}}
                    <span v-if="scope.row.status==0">，未审核</span>
                    <span v-if="scope.row.status==1">，已审核</span>
                    <span v-if="scope.row.status==2">，已完成</span>
                 </div>
		        	</template>
		        </el-table-column>
		        <el-table-column label="操作" align="center" min-width="300" fixed="right">
		        	<template slot-scope="scope">
		        		<el-button type="warning" size="small" round @click="showorder(scope.row)">查看</el-button>
		        		<el-button type="warning" size="small" round @click="getpurcharseorder(scope.row)" v-if="scope.row.type==4">查看采购单</el-button>
                <el-button type="warning" size="small" v-if="scope.row.status==0" round @click="editorder(scope.row)">编辑</el-button>
	              <!-- <el-button type="" size="small" v-if="scope.row.status==2 && scope.row.delorder==1" @click="delCurrent(scope.row)" round>删除</el-button> -->
					    </template>
		        </el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="order.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="order.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_order_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
      	</div>

        <!-- 进货入库单对应的采购单 -->
        <el-dialog title="查询关联的采购单" :visible.sync="purcharseDialog" top="10vh" width="75%">
            <el-table :data="purcharselists" style="width: 100%" v-loading="purcharseLoading">
                <el-table-column type="expand">
		            <template slot-scope="props">
		                <el-table :data="props.row.goods">
                        <el-table-column prop="name" label="商品名称" min-width="250">
                            <template slot-scope="scope">
                                <div style="float:left;width:100%;text-align:left;font-size:13px;line-height:23px">{{scope.row.name}}</div>
                                <div style="float:left;width:100%;text-align:left;font-size:12px;line-height:23px;color:#999999">编号：{{scope.row.number}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="num" label="采购数量" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div style="float:left;width:100%;text-align:center;font-size:14px;line-height:23px">{{scope.row.num}} {{scope.row.unit}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="paynum" label="入库数量" min-width="120" align="center">
                            <template slot-scope="scope">
                                <div style="float:left;width:100%;text-align:center;font-size:14px;line-height:23px">{{scope.row.paynum}} {{scope.row.unit}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="采购价" min-width="120" align="center"></el-table-column>
                        <el-table-column prop="discount" label="折扣(100%)" min-width="120" align="center"></el-table-column>
                        <el-table-column prop="sell" label="折后单价" min-width="120" align="center"></el-table-column>
                        <el-table-column prop="total" label="合计" min-width="120" align="center"></el-table-column>
                    </el-table>
		            </template>
	              </el-table-column>

                <el-table-column label="采购单号" prop="documents" min-width="250">
                    <template slot-scope="scope">
                        <div style="float:left;width:100%;text-align:left;font-size:14px;line-height:23px">{{scope.row.documents}}</div>
                        <div style="float:left;width:100%;text-align:left;font-size:12px;line-height:23px;color:#999999">采购人：{{scope.row.clerkname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" prop="applyname" min-width="120">
                    <template slot-scope="scope">
                        <div style="float:left;width:100%;text-align:center;font-size:14px;line-height:23px">{{scope.row.applyname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="总金额" prop="total" min-width="120" align="center"></el-table-column>
                <el-table-column label="优惠金额" prop="derate" min-width="120" align="center"></el-table-column>
                <el-table-column label="实付金额" prop="deals" min-width="120" align="center"></el-table-column>
                <el-table-column label="状态" min-width="120" align="center">
                    <template slot-scope="scope">
                       <div style="float:left;width:100%;text-align:center;font-size:13px;line-height:23px" v-if="scope.row.isdel==1">已取消</div>
                       <div style="float:left;width:100%;text-align:center;font-size:13px;line-height:23px" v-if="scope.row.isdel==0 && scope.row.status==0">未审核</div>
                       <div style="float:left;width:100%;text-align:center;font-size:13px;line-height:23px" v-if="scope.row.isdel==0 && scope.row.status==1">已审核</div>
                       <div style="float:left;width:100%;text-align:center;font-size:13px;line-height:23px" v-if="scope.row.isdel==0 && scope.row.status==2">已完成</div> 
						        </template>
                </el-table-column>
                <el-table-column label="下单时间" prop="inputtime" min-width="150" align="center"></el-table-column>
            </el-table>
        </el-dialog>

    	
    	<el-dialog title="添加出库单" :visible.sync="addstorageDialog" top="3vh" width="90%">
		    <el-form :inline="true" class="demo-form-inline" ref="search" :model="search" size="medium">
		        <el-form-item>
			        <el-select v-model="create.warehouse" placeholder="收货仓库" style="width:120px">
			          <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
			        </el-select> 
		        </el-form-item> 
		        <el-form-item>
		            <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
		          	    <template slot="prepend">查找</template>
		          	    <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
		            </el-input>
		        </el-form-item>
		        <el-form-item>
		        	<el-button type="primary" @click="addDialogShow">批量添加</el-button>
		        </el-form-item>
		    </el-form>
		    
		    <!---------------------进货入库列表----------------------------->
	    	<el-col :span="24">
	    		<el-col :span="24">
	  	  			<template>
	    				<el-table :data="lists" v-loading="listLoading" border show-summary>
	    					<el-table-column prop="number" label="编号" width="80"></el-table-column>
	    					<el-table-column prop="name" label="商品名称"></el-table-column>
	    					<el-table-column prop="spec" label="规格" width="80" align="center"></el-table-column>
	    					<el-table-column prop="unit" label="单位" width="80" align="center">
	      						<template slot-scope="scope">
	        						<el-input size="medium" :value="scope.row.unit" readonly  @focus="changeUnit(scope.row)"></el-input>
	      						</template>
	    					</el-table-column>
	    					<el-table-column prop="num" label="数量" width="80" align="center" current-row-key="getindex">
						        <template slot-scope="scope">
						        	<el-input size="medium" v-model="nums[scope.$index]"  @blur="changeNum(scope.$index,scope.row)"></el-input>
						        </template>
						    </el-table-column>
						    <el-table-column prop="buy" label="进货价" width="100" align="center"></el-table-column>
						    <el-table-column prop="total" label="小计" width="100" align="center">
						        <template slot-scope="scope">
						        	<el-input size="medium" v-model="totals[scope.$index]"  @blur="changeTotal(scope.$index,scope.row)"></el-input>
						        </template>
						    </el-table-column>
						    <el-table-column prop="validity" label="生产日期" width="155" align="center">
						        <template slot-scope="scope">
						      	    <el-date-picker size="medium" type="date" value-format="yyyy-MM-dd" placeholder="生产日期"   v-model="validitys[scope.$index]"  @blur="changeValidity(scope.$index,scope.row)" style="width:99%;"></el-date-picker>
						        </template>
						    </el-table-column>
						    <el-table-column label="操作" width="50" align="center">
							    <template slot-scope="scope">
							        <i class="el-icon-delete" @click="delcartCurrent(scope.row)"></i>
							    </template>
						    </el-table-column>
	  					</el-table>
	    			</template>
	  			</el-col>
	  			<el-col :span="24">&nbsp;</el-col>
	  			<el-col :span="24">
	  				<div style="border:1px solid #ebeef5;background:#ebeef5;border-radius:6px;padding:20px;margin-bottom:20px;float:left">
					    <el-form ref="create" :model="create" label-width="70px" size="medium">
					    	<el-col :span="6">
						        <el-form-item label="收货仓库" style="width:90%">
							        <el-select v-model="create.warehouse" placeholder="请选择收货仓库">
							            <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
							        </el-select> 
						        </el-form-item> 
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="付款日期" style="width:90%">
						            <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.paydate" style="width:99%;" value-format="yyyy-MM-dd"></el-date-picker>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="付款帐号" style="width:90%">
						            <el-select v-model="create.account" placeholder="请选择付款帐号">
						            	<el-option v-for="(item,index) in accountLists" :key="index" label="未付款" value="0" v-if="item.id==0"></el-option>
						            	<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
						            </el-select>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="单据编号" style="width:90%">
						        	<el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="录单日期" style="width:90%">
						            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择录单日期" v-model="create.inputdate" style="width:99%;"></el-date-picker>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="入库备注" style="width:90%">
						            <el-input placeholder="备注" v-model="create.note"></el-input>
						        </el-form-item>
					        </el-col>
					    </el-form>
	  				</div>
	  			</el-col>
	  		</el-col>
	  		<!------------------------进货入库列表----------------------------->
	  		<div slot="footer" class="dialog-footer">
	      	    <el-button size="" @click="addstorageDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="addorderLoading" @click="createSave">保存</el-button>
	            <el-button size="medium" type="warning" :loading="verifyorderLoading" @click="verifySave">确认审核</el-button>
	            <el-button size="medium" type="danger" :loading="delorderLoading" v-if="create.id > 0 && create.status==0" @click="delSave">删除订单</el-button>
	        </div>
  		</el-dialog>
  		
	    <!---------------------------修改单位--------------------------->
	    <el-dialog title="单位选择" :visible.sync="unitDialog">
	        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
		        <el-table-column label="单位" prop="unit"></el-table-column>
		        <el-table-column label="进货价" prop="buy"></el-table-column>
		        <el-table-column label="市场价" prop="market"></el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="primary" size="small" icon="el-icon-check"  @click="changeUnitSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
	    </el-dialog>
	    <!--------------------------------修改单位end--------------------------->

  	   <!---------------------------批量添加--------------------------->
  	   <el-dialog title="添加产品" :visible.sync="addDialog" width="60%" top="1vh">
       	   <el-form :inline="true" class="demo-form-inline" size="medium">
	      	  <el-form-item style="width:15%">
	              <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
	              	  <el-option label="不分品牌" value="0" ></el-option>
	              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>
	          </el-form-item>
	          <el-form-item style="width:15%">
	              <el-cascader :options="categorylist" v-model="productquery.catid" clearable @change="selectcate"></el-cascader>
	          </el-form-item>
	          <el-form-item ref="productquery" :model="productquery">
	              <el-input placeholder="商品名称 / 编号 / 拼音码 / 条形码" v-model="productquery.key" clearable @keyup.enter.native="getProductList" @change="isnewselect=true"></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
	          </el-form-item>
      	  </el-form>

	      <el-table :data="productlists" style="width: 100%" ref="multipleTable" v-loading="addListLoading" tooltip-effect="dark" @row-click="handleSelectRow" @selection-change="handleSelectionChange">
	          <el-table-column type="selection" width="50"></el-table-column>
	          <el-table-column prop="number" label="编号" width="120"></el-table-column>
	          <el-table-column prop="brandname" label="品牌" width="120"></el-table-column>
	          <el-table-column prop="name" label="名称"></el-table-column>
	          <el-table-column prop="spec" label="规格" width="80"></el-table-column>
	      </el-table>
	      <div class="block">
	      	  <!--分页begin-->
	          <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_product_rows">
	          </el-pagination>
	      	  <!--分页end-->
	      </div>
	      <div slot="footer" class="dialog-footer">
	      	  <el-button size="medium" @click="addDialog = false">取 消</el-button>
	          <el-button size="medium" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
	      </div>
  	  </el-dialog>
  	  <!--------------------------------批量添加end--------------------------->

  	  <!--------------------------------打印--------------------------->
	  <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
	  	  <div style="width:100%;text-align:right">
	  	  	 <!--<span v-if="printorderdetail.printnumber > 0" style="float:left;color:#E6A23C">本订单已打印 {{printorderdetail.printnumber}} 次</span>-->
	  	  	  每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条
	  	  </div>
		  <div id="printContent" v-loading="printLoading">
		      <div v-for="(iit,i) in prpage">
		      	  <span style="float:right">{{iit.id}}/{{allprintpage}}</span>
		      	  <DIV style="font-size:18px;padding-bottom:2px;" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>        
			      <ul class="titlelists">
				  	  <li v-if="printsmodel.pay_date==1">付款日期：{{printorderdetail.paydate}}</li>
					  <li v-if="printsmodel.pay_account==1">付款帐号：{{printorderdetail.accountName}}</li>
					  <li v-if="printsmodel.documents==1">单据编号：{{printorderdetail.documents}}</li>
					  <li v-if="printsmodel.warehouse==1">收货仓库：{{printorderdetail.wareHouseName}}</li>
					  <li v-if="printsmodel.note==1">入库备注：{{printorderdetail.note}}</li>
		  		  </ul>
		          <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;margin-top:2px;font-size:15px" bordercolor="#333333">
	      		  	  <TR class="contactcontent">
				      	  <TD v-if="printsmodel.number==1"><DIV align=center><b>编号</b></DIV></TD>
				          <TD v-if="printsmodel.product_name==1"><DIV align=center><b>品名</b></DIV></TD>
				          <TD v-if="printsmodel.product_spec==1"><DIV align=center><b>规格</b></DIV></TD>
				          <TD v-if="printsmodel.unit==1"><DIV align=center><b>单位</b></DIV></TD>
				          <TD v-if="printsmodel.num==1"><DIV align=center><b>数量</b></DIV></TD>
				          <TD v-if="printsmodel.purchase==1"><DIV align=center><b>进货价</b></DIV></TD>
				          <TD v-if="printsmodel.account==1"><DIV align=center><b>小计</b></DIV></TD>
				          <TD v-if="storageLocationStatus"><DIV align=center><b>收货货位</b></DIV></TD>
				          <TD v-if="batchStatus && printsmodel.batch_sn == 1"><DIV align=center><b>批次号</b></DIV></TD>
				          <TD><DIV align=center><b>生产日期</b></DIV></TD>
				          <TD v-if="batchStatus && printsmodel.validity==1"><DIV align=center><b>有效期</b></DIV></TD>
				          <TD v-if="batchStatus && printsmodel.end_date==1"><DIV align=center><b>到期日期</b></DIV></TD>
			          </TR>
			          <tr v-for="(item,index) in printorderdetail.goods" :key="index" class="contactcontent" v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage'] ">
				          <TD v-text="item.number" align="center" v-if="printsmodel.number==1"></TD>
				          <TD v-text="item.name" style="padding-left:20px" v-if="printsmodel.product_name==1"></TD>
				          <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec==1"></TD>
				          <TD v-text="item.unit" align="center" v-if="printsmodel.unit==1"></TD>
				          <TD v-text="item.num" align="center" v-if="printsmodel.num==1"></TD>
				          <TD align="center" v-if="printsmodel.purchase==1">{{item.buy|CFMprice}}</TD>
				          <TD align="center" v-if="printsmodel.account==1">{{item.total|CFMprice}}</TD>
				          <TD v-if="storageLocationStatus" align="center" >{{ item.storage_location_code || '/' }}</TD>
				          <TD v-if="batchStatus && printsmodel.batch_sn == 1" align="center" >{{ item.batch_sn || '/' }}</TD>

                  <!-- 不开启批次的生产日期 -->
				          <TD v-if="!batchStatus" align="center" >{{ item.validity || '/' }}</TD>
                  <!-- 开启批次的生产日期 -->
				          <TD v-if="batchStatus" align="center" >{{ item.start_date || '/' }}</TD>
                 
				          <TD v-if="batchStatus && printsmodel.validity==1" align="center" >
                    {{ item.realvalidity }}{{ validityunitTemp[item.validityunit] }}
                  </TD>
                  <TD v-if="batchStatus && printsmodel.end_date==1" align="center" >{{ item.end_date || '/' }}</TD>
			          </tr>
			          <tr v-if="iit.id==allprintpage">
				          <TD align="center" v-if="printsmodel.number==1 || printsmodel.product_name==1"><b>合计</b></TD>
				          <TD v-if="printsmodel.number==1 && printsmodel.product_name==1"></TD>
				          <TD v-if="printsmodel.product_spec==1">&nbsp;</TD>
				          <TD v-if="printsmodel.unit==1">&nbsp;</TD>
				          <TD align="center" v-if="printsmodel.num==1">{{printorderdetail.goodscount}}</TD>
				          <TD v-if="printsmodel.purchase==1">&nbsp;</TD>
				          <TD align="center" v-if="printsmodel.account==1">{{printorderdetail.total|CFMprice}}</TD>
				          <TD v-if="storageLocationStatus" >&nbsp;</TD>
				          <TD v-if="batchStatus && printsmodel.batch_sn == 1">&nbsp;</TD>
				          <TD >&nbsp;</TD>
				          <TD  v-if="batchStatus && printsmodel.validity==1">&nbsp;</TD>
				          <TD  v-if="batchStatus && printsmodel.end_date==1">&nbsp;</TD>
			          </tr>
		      	  </table>
			      <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="margin-top:2px;font-size:15px">
			          <TBODY>
				          <TR>
					          <TD v-if="printsmodel.inputtime==1">录单日期：{{printorderdetail.inputdate}}</TD>
					          <TD v-if="printsmodel.sysmanagername==1">操作人：{{printorderdetail.sysmanagername}}</TD>
				          </TR>
			      	  </TBODY>
			      </TABLE>
			      <div class="pageBreak"></div>
			  </div>
		  </div>
	      <div slot="footer" class="dialog-footer">
	        <el-button size="small" @click="printerDialog = false">取 消</el-button>
	        <el-button size="small" type="primary" @click="createnoSave" :loading="printorderLoading">打印</el-button>
	        <el-button size="small" type="danger" @click="cannelSave" :loading="cannelorderLoading" v-if="printorderdetail.status==1">撤销审核</el-button>
	        <el-button size="small" type="danger" @click="finishSave" :loading="finishorderLoading" v-if="printorderdetail.status==1">完成订单</el-button>
	      </div>
	  </el-dialog>
	  <!--------------------------------打印end--------------------------->
  </div>
  </transition>      
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Storage/index",
      transitionshow:true,
      actionauth:[],
      addstorageDialog:false,
      lists:[],
      listLoading:false,
      total_order_rows:0,
      orderListLoading:false,
      order:{
      	act:'getorderlists',
        token:this.$cookies.get('token'),
        date:'',
        warehouse:'',
        applyid:'',
        key:'',
        status:'',
        account:'',
        type:'',
        p:1,
        rollpage:10
      },
      search:{
        act:'barcode',
        token:this.$cookies.get('token'),
        key:''
      },
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        rollpage: 1000, // 页大小
        p: 1
      },
      total_rows:0,
      wareHouseLists:[],
      accountLists:[],
      nums:[],
      totals:[],
      validitys:[],
      create:{
        act:'add',
        token:this.$cookies.get('token'),
        id:'',
        warehouse:'',
        paydate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
        account:'',
        documents:'',
        inputdate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
        note:'',
        status:'',
      },
      unitLoading:false,
      unitDialog:false,
      unitlists:[],
      unitListLoading:false,
      changeunitid:0,
      addDialog:false,
      addListLoading:false,
      productquery:{
        act:'lists',
        token:this.$cookies.get('token'),
        brandid:'',
        catid:[],
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      productlists:[],
      brandlists:[],
      categorylist:[],
      total_product_rows:0,
      addProductLoading:false,
      multipleSelection: [],
      printerDialog:false,
      accountName:'',
      wareHouseName:'',
      totalPrice:'',
      
      printsmodel:[],
      isnewselect:false,
      
      prpage:[],
	  prollpage:[],
	  prtotal:0,
	  rollpage:'',
	  allprintpage:'',
      orderisselect:false,
      printLoading:false,
      printorderdetail:[],
      printorderLoading:false,
      addorderLoading:false,
      verifyorderLoading:false,
      delorderLoading:false,
      addneworderLoading:false,
      cannelorderLoading:false,
      finishorderLoading:false,
      statuslists:[
      	{id:0,name:'未审核'},
      	{id:1,name:'已审核'},
      	{id:2,name:'已完成'},
      	{id:4,name:'已撤销'},
      ],
      ordertype: [
      	{id:1,name:'按入库单'},
      	{id:4,name:'按采购单'},
      ],
      isverifystorage:false,
      allapplylists:[],
      showformmore:{height:'3em'},
      purcharselists:[],
      purcharseLoading:false,
      purcharseDialog:false,
      typeTemp: {
        2: '退',
        3: '盘',
        4: '采'
      },
      batchStatus: false,
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
      storageLocationStatus: false
    }
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },
  created() { 
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
  },
  mounted(){
    this.getWarehouse(); //获取仓库信息
    this.getAccount(); //获取支付信息
    //this.getList(); //获取购物车商品信息
    this.getOrderlists(); //获取销售订单列表
    //this.setDocuments(); //获取进货单号
    this.getCategoryList(); //获取商品分类
    this.getprintsmodel(); //获取打印模板
    this.getactionauth(); //获取权限设置
    //this.getaddauth(); //获取进货入库按钮的权限
    this.getAllapplylists(); //获取供应商信息
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
  },
  methods:{

    /** 调整数字格式 **/
    changepriceformat(value) { 
        var price=parseFloat(value); //修剪去小数点后多余的0
        var numsobj=price.toString().split(".");	//判断小数点后有几位小数

        if(numsobj.length==1) return price.toFixed(2); //值为0时补充到2位
        if(numsobj.length > 1 && numsobj[1].length <= 2) return price.toFixed(2); //值为小数点后只有1位小数时补充到2位
        if(numsobj.length > 1 && numsobj[1].length > 2) return price; //小数点后的值超出2位时直接返回
    }, 
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    
    /** 获取全部供应商列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    //获取订单信息列表
    getOrderlists() {
    	if(this.orderisselect==true) {
    		this.order.p=1;
    		this.order.rollpage=10;
    	}
    
    	this.orderListLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.order).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.orderListLoading=false;
            }else{
                this.orderlists = JSON.parse(Base64.decode(res.data.Data));
                this.total_order_rows=parseInt(res.data.count);
                this.orderListLoading=false;
                if(this.orderisselect==true) this.orderisselect=false;

                //打印完成刷新页面时重新加载参数
                if(this.$cookies.get('print_back_data_Storage') && this.$cookies.get('print_back_data_Storage')!='') {
                    var data=this.$cookies.get('print_back_data_Storage');
                    data=JSON.parse(data);
                    this.orderisselect=data.orderisselect;
                    this.order=data.order;
                    this.$cookies.set('print_back_data_Storage','');
                    this.getOrderlists();
                }

            }
        }).catch((res) => {
            this.orderListLoading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.order.rollpage = val;
        this.getOrderlists();
    },
    orderPageCurrentChange(val) {
        this.order.p = val;
        this.getOrderlists();
    },
    
    
    /** 进货单号 **/
    setDocuments(){
      var resource = this.$resource(this.url);
      resource.query({act:'getjhdocuments',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.create.documents=result;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 自定义修改订单编号 **/
    changeDocuments(code) {
    	var title=code.substring(0,2); 
    	var year=code.substring(2,6); 
    	var month=code.substring(6,8); 
    	var day=code.substring(8,10); 
    	var number=code.substring(10,15); 
    	return title+'-'+year+'-'+month+'-'+day+'-'+number;
    },
    
    
    /** 获取仓库 **/
    getWarehouse(){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
      var resource = this.$resource(this.GLOBAL.domain+"Account/index");
      resource.query({act:'lists',isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    

    /** 信息列表 **/
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          const _this=this;
          this.lists.forEach(function(e,index){  
            _this.nums.splice(index, 1, e.num);
            _this.totals.splice(index,1,e.total);
            _this.validitys.splice(index,1,e.validity);
          });
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 修改单位 **/
    changeUnit(item){
      this.unitDialog=true;
      this.unitListLoading = true;
      this.changeunitid=item.id;
      var resource = this.$resource(this.url);
      resource.query({ act:'getunit',productid:item.productid,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        }else{
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.unitListLoading=false;
      });
    },
    
    
    /** 确认修改单位 **/
    changeUnitSave(item){
      this.unitListLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changeunit',id:item.id,tempid:this.changeunitid,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.unitListLoading=false;
          }else{
            this.unitListLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.unitListLoading=false;
      });
      this.unitDialog=false;
    },
    
    
    /** 修改数量 **/
    changeNum(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changenum',id:item.id,num:this.nums[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    
    /** 修改总价 **/
    changeTotal(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changetotal',id:item.id,total:this.totals[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    /** 修改有效期 **/
    changeValidity(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changevalidity',id:item.id,validity:this.validitys[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    
    /** 删除 **/
    delcartCurrent(item){
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    
    /** 扫码添加商品 **/
    addDialogsingle() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'sweep',key:this.productquery.key,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	if(Base64.decode(res.data.Data)==1) { //有1个以上则展开列表 
	        		this.addDialogShow();
	        		this.productquery.key='';
	        	}else { //扫码解析同一个产品只有1个则直接添加
	        		this.multipleSelection=[];
	        		this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
	        		this.addSave();
	        		this.productquery.key='';
	        	}
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 批量添加 **/
    addDialogShow(){
      this.addDialog=true;
      this.getBrand();
      this.getProductList();
    },
    
    
    /** 获取品牌 **/
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 产品信息列表 **/
    getProductList(){
      if(this.isnewselect==true) {
		  this.productquery.p=1;
		  this.productquery.rollpage=10;	    	
   	  }
    
      this.addListLoading = true;
      var resource = this.$resource(this.GLOBAL.domain+"Product/index");
      resource.query(this.productquery).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        }else{
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows=parseInt(res.data.count);
          this.addListLoading = false;
        }
        
        if(this.isnewselect==true) this.isnewselect=false;
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addListLoading=false;
          if(this.isnewselect==true) this.isnewselect=false;
      });
    },
    
    
    productPageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    productPageCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    },
    
    
    /** 确认添加商品 **/
    addSave(){
      this.addProductLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'addproduct',productid:this.multipleSelection,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.addProductLoading=false;
          }else{
            this.$message.success(res.data.Message);
            this.addDialog=false;
            this.addProductLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addDialog=false;
          this.addProductLoading=false;
      });
    },
    
    
    /** 点击单行选择产品 **/
    handleSelectRow(row,event,column) {
    	var _this=this;
    	var val=[];
    	val.push(row);
    	var number=0;
    	var id=row.id;
    	var isin=[];
    	
    	this.productlists.forEach(function(e,index) {
    		if(e.id==id) number=index;
    	});
    	this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);    	
    	this.multipleSelection.forEach(function(e,index) {isin.push(e.id)});
    	
    	//检测是否添加产品进购物车
    	if(inArray(id,isin)) {
    		this.multipleSelection.forEach(function(e,index) {
    			if(e.id==id) this.multipleSelection.splice(index,1);
    		});
    	}else {
    		this.multipleSelection.push(row);
    	}
    	
    },
    
    handleSelectionChange(val) {
       this.multipleSelection = val;
    },
    
    
    /** 保存订单 **/
    createSave(){
        this.addorderLoading=true;
        var resource = this.$resource(this.url);
        //实时更新单据编号信息
        this.setDocuments();
        this.create.act='add';
        resource.save(this.create).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.addorderLoading=false;
            }else{
              this.$message.success(res.data.Message);
              this.createDialog=false;
              this.addorderLoading=false;
              this.getList();
              this.setDocuments(); //重新获取单据编号
              this.create.id='';
              this.create.warehouse='';
              this.create.account='';
              this.create.note='';
              this.getOrderlists();
              this.addstorageDialog=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog=false;
            this.listLoading=false;
        });
    },
    
    
    /** 确认审核订单 **/
    verifySave(){
        this.verifyorderLoading=true;
        var resource = this.$resource(this.url);
        //实时更新单据编号信息
        this.setDocuments();
        this.create.act='verify';
        resource.save(this.create).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.verifyorderLoading=false;
            }else{
              this.$message.success(res.data.Message);
              this.createDialog=false;
              this.addorderLoading=false;
              this.getList();
              this.setDocuments(); //重新获取单据编号
              this.create.id='';
              this.create.warehouse='';
              this.create.account='';
              this.create.note='';
              this.getOrderlists();
              this.addstorageDialog=false;
              this.verifyorderLoading=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog=false;
            this.listLoading=false;
            this.verifyorderLoading=false;
        });
    },
    
    
    /** 获取帐户名称 **/
    getAccountName(id){
      var resource = this.$resource(this.GLOBAL.domain+"Account/index");
      resource.query({act:'getname',id:id,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.accountName=res.data.Message;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 获取仓库名称 **/
    getWareName(id){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'getname',id:id,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.wareHouseName=res.data.Message;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 获取总价 **/
    getTotal(){
      var resource = this.$resource(this.url);
      resource.query({act:'gettotal',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.totalPrice=res.data.Message;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 新增并且打印 **/
    createPrint(){
      if(this.lists=='') {this.$message.error("请选择要入库的商品！");return false;}
      if(this.create.warehouse=='') {this.$message.error("请选择收货仓库！");return false;}
      if(this.create.account=='') {this.$message.error("请选择付款账号！");return false;}
    	
      this.printerDialog=true;
      this.getAccountName(this.create.account);
      this.getWareName(this.create.warehouse);
      this.getTotal();
      
      //设置打印分页显示信息
      this.changepage();
      
    },
    
    
    /** 打印 **/
    printContent(){
        this.createSave();
        var div_print=document.getElementById('printContent');
        var newStr=div_print.innerHTML;
        var oldStr=document.body.innerHTML;
        document.body.innerHTML=newStr;
        window.print();
        document.body.innerHTML=oldStr;
        location.reload();
    },
    
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	          this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取打印模板设置 **/
    getprintsmodel() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'getmodelsetting',id:2,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	          this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
	          this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
	        }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    
    /** 修改每页条数 **/
    changepagevlaue() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	    resource.query({act:'changepagesize',id:90,num:this.rollpage,token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        this.changepage();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    /** 设置分页设置 **/
    changepage() {
    	var number=this.rollpage; //系统设置的每页条数
    	this.prtotal=this.printorderdetail.goods.length; //总条数
    	this.prpage=[];
    	this.prollpage=[];
    	
    	if(number >= this.prtotal) {
    		this.prpage.push({id:1});
    		this.prollpage.push({startpage:0,endpage:number});
    		this.allprintpage=1;
    	}else {
    		var tnumber=parseInt(this.prtotal/number);
    		var lnumber=this.prtotal%number;
    		var index;
    		var start;
    		var end;
    		lnumber > 0 ? tnumber++ : '';
    		this.allprintpage=tnumber;
    		
    		for (var i=0;i<tnumber;i++) {
				index=i+1;
				this.prpage.push({id:index});
				start=i*number;
				end=index*number-1;
				this.prollpage.push({startpage:start,endpage:end});
			}
    	}
    },
    
    
    //展示打印确认页
    showorder(item) {
    	this.getprintdetail(item.id);
    },
    
    
    //获取订单打印信息
    getprintdetail(id) {
    	this.printerDialog=true;
    	this.printLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query({act:'getprintinfos',token:this.$cookies.get('token'),id:id}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printLoading=false;
	        }else{
		        this.printorderdetail=JSON.parse(Base64.decode(res.data.Data));
            console.log(this.printorderdetail, '进货入库确认打印')
		        
		        //对商品进行分页设置
		        var number=this.rollpage; //系统设置的每页条数
    			this.prtotal=this.printorderdetail.goods.length; //总条数
    			this.prpage=[];
    			this.prollpage=[];
    	
    			if(number >= this.prtotal) {
		    		this.prpage.push({id:1});
		    		this.prollpage.push({startpage:0,endpage:number});
		    		this.allprintpage=1;
    			}else {
		    		var tnumber=parseInt(this.prtotal/number);
		    		var lnumber=this.prtotal%number;
		    		var index;
		    		var start;
		    		var end;
		    		lnumber > 0 ? tnumber++ : '';
		    		this.allprintpage=tnumber;
		    		for (var i=0;i<tnumber;i++) {
						index=i+1;
						this.prpage.push({id:index});
						start=i*number;
						end=index*number-1;
						this.prollpage.push({startpage:start,endpage:end});
					}
          
		   		}
		        this.printLoading=false;
	        }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	          this.printLoading=false;
	      });
      },
      
      /** 订单信息打印 **/
      createnoSave(){ 
    	  this.printorderLoading=true;  
          var resource = this.$resource(this.url);  
          resource.save({act:'updateprintnumber',token:this.$cookies.get('token'),id:this.printorderdetail.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.printorderLoading=false;  
              }else{             
                  this.printlocalpage(); //打印 
              }
          }).catch((res) => {
              this.printorderLoading=false;  
          });
      },
      
      /** 打印当前页面 **/
      printlocalpage() {
      	//设置打印完成后回调页面
    	  this.$cookies.set('returnurlids','Storage');
        //保留搜索前的数据
		    var data={};
		    data.orderisselect=this.orderisselect;
	 	    data.order=this.order;
		    this.$cookies.set('print_back_data_Storage',JSON.stringify(data));


    	  //设置打印信息
    	  var div_print=document.getElementById('printContent');
	      var newStr=div_print.innerHTML;
	      var oldStr=document.body.innerHTML;
	      document.body.innerHTML=newStr;
	      window.print();
	      document.body.innerHTML=oldStr;	    
	      location.reload();
      },
      
      /** 新增退款订单 **/
      addnews() {
      	  this.$emit('listenchild',{name:'新增进货入库单',url:'Storageadd'});
      	  /**
      	  this.addneworderLoading=true;
      	  var resource = this.$resource(this.url);
          resource.save({ act:'deltemplists',token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.addneworderLoading=false; 
      	  		  this.addstorageDialog=true;
                  this.getList();
                  
                  //清空出库单信息
                  this.create.id='';
                  this.create.warehouse='';	
		          this.create.paydate=new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate();
		          this.create.paydate.account='';
		          this.create.paydate.documents='';
		          this.create.paydate.inputdate=new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate();
		          this.create.paydate.note='';
		          this.create.paydate.status='';                  
              }
          }).catch((res) => {
          	  this.addneworderLoading=false;
          });
          */
      },
      
     //删除未审核的订单
     delSave() {
     	this.$confirm('您是否确定要删除该进货单, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              this.delorderLoading=true;
              var resource = this.$resource(this.url);
              resource.save({ act:'delSave',id: this.create.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                      this.delorderLoading=false;
                  }else{
                    this.$message.success('删除入库单成功!');
                    this.delorderLoading=false;
                    this.addstorageDialog=false;
                    this.getOrderlists();
                  }
              }).catch((res) => {
                  this.delorderLoading=false;
              });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
     },
     
     
     //删除未审核的订单
     cannelSave() {
     	this.$confirm('您是否确定要将该出货单从已审核状态撤销回未审核状态, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              this.cannelorderLoading=true;
              var resource = this.$resource(this.url);
              resource.save({ act:'cannelSave',id: this.printorderdetail.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                      this.cannelorderLoading=false;
                  }else{
                    this.$message.success('撤销入库单审核成功!');
                    this.cannelorderLoading=false;
                    this.printerDialog=false;
                    this.getOrderlists();
                  }
              }).catch((res) => {
                  this.cannelorderLoading=false;
              });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
     },
     
     //完成订单
     finishSave() {
     	this.$confirm('您是否确定要完成该进货单, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              this.finishorderLoading=true;
              var resource = this.$resource(this.url);
              resource.save({ act:'finishSave_news',id: this.printorderdetail.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                      this.finishorderLoading=false;
                  }else{
                    this.$message.success('该入库单已完成！');
                    this.finishorderLoading=false;
                    this.printerDialog=false;
                    this.getOrderlists();
                  }
              }).catch((res) => {
                  this.finishorderLoading=false;
              });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
     },
     
     
     //编辑订单信息
     editorder(item) {
     	this.$emit('listenchild',{name:'编辑进货入库单',url:'Storageedit',data:item});
     	/**
     	this.addstorageDialog=true;
        var resource = this.$resource(this.url);
        resource.save({act:'getOrderinfos',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var result=JSON.parse(Base64.decode(res.data.Data));
	        	this.create.id=result.id;
	        	this.create.warehouse=result.warehouse;
	        	this.create.paydate=result.paydate;
	        	this.create.account=result.account;
	        	this.create.documents=result.documents;
	        	this.create.inputdate=result.inputdate;
	        	this.create.status=result.status;
	        	this.create.note=result.note;
	        	this.getList();
	        }    
        }).catch((res) => {
                  
        });
        */
     },
       
      
      
    //删除单个
    delSingleCurrent(item){
        this.$confirm('此操作将撤销 ' + item.name + ' 进货记录, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delsinglerecord',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功撤销了' + item.name + '!');
                    this.getOrderlists();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
    //删除
    delCurrent(item){
      this.$confirm('此操作将撤销 ' + item.documents + ' 进货记录, 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delrecord_news',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功撤销了' + item.documents + '!');
                    this.getOrderlists();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    //获取进货入库按钮权限
    getaddauth() {
    	  var resource = this.$resource(this.url);
        resource.query({ act:'isverifystorage',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result=JSON.parse(Base64.decode(res.data.Data));
                this.isverifystorage=result.isverifystorage;
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //展开、收缩表单多选
    getmoreselect() {
    	this.showformmore.height=='3em' ? this.showformmore.height='6em' : this.showformmore.height='3em';
    },


    //获取进货入库单对应的采购单信息
    getpurcharseorder(item) {
        this.purcharseLoading=true;
        this.purcharseDialog=true;
        this.purcharselists=[];

        var resource = this.$resource(this.url);
        resource.query({ act:'getinputpurcharseinfo',token:this.$cookies.get('token'),id:item.id}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.purcharseLoading=false;
            }else{
                var result=JSON.parse(Base64.decode(res.data.Data));
                console.log( result, 'GONGYINGS')
                this.purcharselists.push(result);
                this.purcharseLoading=false;
            }
        }).catch((res) => {
        	  //this.$message.error(this.GLOBAL.errortext);
            this.purcharseLoading=false;
        });
    },
      
    
  }
}
</script>

<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.titlelists {float:left;width:100%;padding:0;margin:0}
.titlelists li {float:left;width:33.3%;font-size:15px;list-style-type:none}
.top1 td {padding-top:5px;font-size:15px}
.top2 td {padding-top:15px;font-size:15px}
.formmore {overflow:hidden;transition: height 0.3s 0s;}
</style>


// WEBPACK FOOTER //
// src/components/purchase/Storage.vue